import { cloneElement, isValidElement, useMemo } from 'react';
import { Tooltip } from 'react-tooltip'
import { v4 } from 'uuid';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const TooltipWrapper = ({ children, text = "", className = "", style = {}, html = null, component = null }) => {

  const id = useMemo(() => v4(), [])
  const hasTooltipContent = Boolean(component || html || text)

  const tooltipStyle = {
    whiteSpace: "normal",
    maxWidth: "512px",
    zIndex: 9999,
    borderRadius: "16px",
    color: "#000",
    textTransform: "none",
    fontWeight: 400,
    backgroundColor: '#fff',
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    ...style
  }

  return (
    <>
      {isValidElement(children)
        ? cloneElement(children, hasTooltipContent ? { "data-tooltip-id": id } : {})
        : <span {...(hasTooltipContent ? { "data-tooltip-id": id } : {})}>{children}</span>}
      {hasTooltipContent &&
        <Tooltip
          id={id}
          positionStrategy="absolute"
          multiline={true}
          place="top"
          offset={8}
          opacity={1}
          style={tooltipStyle}
        >
          <div className={className} style={{
            textTransform: "none",
            fontWeight: 400,
            ...style,
          }}>
            {component && component}
            {!component && html && <div dangerouslySetInnerHTML={{ __html: html }} />}
            {!component && !html && text && <Markdown rehypePlugins={[rehypeRaw]}>{text}</Markdown>}
          </div>
        </Tooltip>
      }
    </>
  );
};

export default TooltipWrapper;
